import { Navigate } from 'react-router-dom';
import { GUIDE_ROUTES } from '@/features/guide/constants/routes';

export function GuideWithdrawalsPage() {
  return <Navigate to={`${GUIDE_ROUTES.WALLET}?tab=withdrawals`} replace />;
}
